module.exports = __webpack_public_path__ + "static/logo2-5abcb8324fe417df213e86310870c011.svg";